import ProgressCircle from './ProgressCircle';
import ProgressLine from './ProgressLine';
var Progress = ProgressLine;
Progress.Line = ProgressLine;
Progress.Circle = ProgressCircle;
export default Progress;